import i18n from '@dms/i18n';
import {SettingsTemplate} from '@dms/settings/shared';

import {RecordAuditSeriesDefinitionList} from './components/RecordAuditSeriesDefinitionList';

export function RecordAuditSeriesDefinition() {
  return (
    <SettingsTemplate
      header={{title: i18n.t('page.settings.recordAuditSeriesDefinition.title')}}
      data-testid="settings-record-audit-series-definition"
      description={i18n.t('page.settings.recordAuditSeriesDefinition.description')}
    >
      <RecordAuditSeriesDefinitionList />
    </SettingsTemplate>
  );
}
